import { render } from "./PromotionDetail.vue?vue&type=template&id=d072bb8a&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"

import "./PromotionDetail.vue?vue&type=style&index=0&id=d072bb8a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d072bb8a"]])

export default __exports__